import axios from 'axios';
import { viewTypeList, scaleList, measurmentTypeList, timePeriodList, deathTypeList, getDeathTypeObject, getMeasurmentTypeObject } from '../store/StaticVariables';

export const toSlug = (...args) => {
    return [...args].filter((e) => e).join('_');
};
export const generateMapAttribute = ({ type, deathType, measurement }) => {
    if (type !== 'deaths') return 'rate_sym_ed';
    return toSlug(getMeasurmentTypeObject(measurement).attr, 'SYM', getDeathTypeObject(deathType).attr).toLowerCase();
};
export const generateDisplayAttribute = ({ type, deathType, measurement, modeled = false }) => {
    if (type !== 'deaths') return String(modeled ? 'Rate_M_ED' : 'Rate_ED').toLowerCase();
    const attrType = measurement === 'count' ? 'SUP' : modeled ? 'M' : '';
    return toSlug(getMeasurmentTypeObject(measurement).attr, attrType, getDeathTypeObject(deathType).attr).toLowerCase();
};
export const ceilOrString = (value) => {
    if (typeof value === 'string') return value;
    return Math.ceil(value);
};
export const objectKeysToLowerCase = (inputObj) => {
    const outputObj = {};
    Object.keys(inputObj).forEach((key) => {
        outputObj[key.toLowerCase()] = inputObj[key];
    });
    return outputObj;
};
export const standardizeObjectKeys = (inputObj) => {
    const outputObj = objectKeysToLowerCase(inputObj);
    if ('GEOID' in inputObj) outputObj.GEOID = inputObj.GEOID;
    if ('ST_GEOID' in inputObj) outputObj.ST_GEOID = inputObj.ST_GEOID;
    if ('geoid' in inputObj && !('GEOID' in inputObj)) outputObj.GEOID = inputObj.geoid;
    if ('st_geoid' in inputObj && !('ST GEOID' in inputObj)) outputObj.ST_GEOID = inputObj.st_geoid;
    return outputObj;
};

export const mapFeatureServiceObjectToMapServiceObject = (input) => {
    const obj = input.attributes;

    const outputFeature = {
        Count_SUP_ALL: obj.count_sup_all,
        Count_SUP_Homicide: obj.count_sup_homicide,
        Count_SUP_Suicide: obj.count_sup_suicide,
        Count_SYM_ALL: obj.count_sym_all,
        Count_SYM_Homicide: obj.count_sym_homicide,
        Count_SYM_Suicide: obj.count_sym_suicide,
        Rate_ed: obj.rate_ed,
        Rate_CI_ED: obj.rate_ci_ed,
        Rate_M_ED: obj.rate_m_ed,
        Rate_SYM_ED: obj.rate_sym_ed,
        GEOID: obj.geoid,
        NAME: obj.name,
        OBJECTID: obj.objectid,
        Rate_ALL: obj.rate_all,
        Rate_CI_ALL: obj.rate_ci_all,
        Rate_CI_Homicide: obj.rate_ci_homicide,
        Rate_CI_Suicide: obj.rate_ci_suicide,
        Rate_Homicide: obj.rate_homicide,
        Rate_M_ALL: obj.rate_m_all,
        Rate_M_Homicide: obj.rate_m_homicide,
        Rate_M_Suicide: obj.rate_m_suicide,
        Rate_SYM_ALL: obj.rate_sym_all,
        Rate_SYM_Homicide: obj.rate_sym_homicide,
        Rate_SYM_Suicide: obj.rate_sym_suicide,
        Rate_Suicide: obj.rate_suicide,
        ST_NAME: obj.st_name, //not all features have this
        AGG_COUNT: obj.agg_count, //not all features have this
        ST_GEOID: obj.st_geoid, //not all features have this
        Shape: obj.SHAPE__Length
    };
    return outputFeature;
};

export const geometryScaleFromGeoid = (geoid) => {
    const sgeoid = String(geoid + '');
    if (sgeoid === '1') return 'us';
    if (isNaN(sgeoid.substring(0, 2))) return 'census';
    if (sgeoid.indexOf('-') !== -1) return 'zcta';
    if (sgeoid.length === 2) return 'usstate';
    if (sgeoid.length === 5) return 'county';
    return '';
};

//Deprecated
const generateStyleLayers = () => {
    const jsonLayerMissingTemplate = {
        id: '_missing',
        type: 'fill',
        source: 'esri',
        'source-layer': '',
        filter: ['==', '_symbol', 1],
        layout: {
            visibility: 'none'
        },
        paint: {
            'fill-color': '#C2C2C1',
            'fill-opacity': 0.75,
            'fill-outline-color': '#6E6E6E'
        }
    };
    const jsonLayerStepFillTemplate = {
        id: '_fill',
        type: 'fill',
        source: 'esri',
        'source-layer': '',
        filter: ['==', '_symbol', 2],
        layout: {
            visibility: 'none'
        },
        paint: {
            'fill-color': '#cccccc',
            'fill-opacity': 0.75,
            'fill-outline-color': '#6E6E6E'
        }
    };
    const hoveredFeatureStyleLayer = {
        id: 'hovered_feature',
        type: 'line',
        source: 'esri',
        'source-layer': 'State',
        filter: ['==', 'GEOID', '0'],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': '#ff0000',
            'line-width': 2,
            'line-opacity': 1
        }
    };
    const selectedFeatureStyleLayer = {
        id: 'selected_feature',
        type: 'line',
        source: 'esri',
        'source-layer': 'State',
        filter: ['==', 'GEOID', '0'],
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'fill-color': '#ff0000',
            'line-color': '#000000',
            'line-width': 3,
            'line-opacity': 1
        }
    };
    const layers = [];
    let layerSteps = [
        { name: 'low', equalStep: 2, greaterStep: '0.2' },
        { name: 'mlow', equalStep: 3, greaterStep: '0.4' },
        { name: 'med', equalStep: 4, greaterStep: '0.6' },
        { name: 'high', equalStep: 5, greaterStep: '0.8' }
    ];
    const colorSchemes = {
        red: '#CB4020,#D34723,#AB2312,#840000',
        blue: '#1F82CB,#155EB4,#0A399C,#001485',
        green: '#6EBCB3,#4AA58F,#258D6A,#007546',
        orange: '#E9A23D,#E18E2A,#D87916,#D06502',
        purple: '#743DDD,#5F28CD,#4914BC,#3300AB',
        brown: '#7B5B47,#6E4E34,#624022,#563210',
        aqua: '#63ACB7,#468A94,#286771,#0A454E',
        lightblue: '#77A8DE,#5185DD,#2B62DD,#053FDD',
        pink: '#D98DB9,#C65E9D,#B33080,#A00163',
        lightgreen: '#87D3AF,#5BBC9A,#2EA684,#02906E',
        olive: '#94B268,#7D9F45,#678D23,507B00',
        mixed: '#93B0AA,#6DA6A0,#6DA6A0,# 489B95,#23908A'
    };
    const dataAttributeObjList = [
        { name: 'deaths_homicide_rate', jsonAttr: '_symbol', filter: '==', colors: colorSchemes.red },
        { name: 'deaths_homicide_count', jsonAttr: 'HHB_RANK', filter: '>', colors: colorSchemes.blue },
        { name: 'deaths_suicide_rate', jsonAttr: 'SEN_RANK', filter: '>', colors: colorSchemes.green },
        { name: 'deaths_suicide_count', jsonAttr: 'SOCIODEM_RANK', filter: '>', colors: colorSchemes.orange },
        { name: 'ed_visits_rate', jsonAttr: 'NBE_RANK', filter: '>', colors: colorSchemes.purple },
        { name: 'ed_visits_count', jsonAttr: 'OVERALL_RANK', filter: '>', colors: colorSchemes.brown }
    ];
    scaleList.forEach((scale) => {
        dataAttributeObjList.forEach((attrObj) => {
            let colorScheme = attrObj.colors.split(',');

            let missingStyleLayer = Object.assign({}, jsonLayerStepFillTemplate);
            missingStyleLayer.id = scale.slug + '_' + attrObj.name + jsonLayerMissingTemplate.id;
            missingStyleLayer.filter = [attrObj.filter, attrObj.jsonAttr, attrObj.filter == '>' ? '0.1' : 1];
            missingStyleLayer['source-layer'] = scale.layerName;
            layers.push(missingStyleLayer);
            layerSteps.forEach((step, i) => {
                let stepStyleLayer = Object.assign({}, jsonLayerMissingTemplate);
                stepStyleLayer.id = scale.slug + '_' + attrObj.name + '_' + step.name;
                stepStyleLayer.filter = [attrObj.filter, attrObj.jsonAttr, attrObj.filter == '>' ? step.greaterStep : step.equalStep];
                stepStyleLayer['source-layer'] = scale.layerName;
                stepStyleLayer.paint = Object.assign({}, jsonLayerStepFillTemplate.paint);
                stepStyleLayer.paint['fill-color'] = colorScheme[i];
                layers.push(stepStyleLayer);
            });
        });
    });
    layers.push(hoveredFeatureStyleLayer, selectedFeatureStyleLayer);
    console.log(layers);
    //
};
export { generateStyleLayers };

//Deprecated
export const generateDataSlugList = () => {
    var dataSlugMapping = {};
    var i = 0;
    viewTypeList.forEach((view) => {
        scaleList.forEach((scale) => {
            measurmentTypeList.forEach((measure) => {
                timePeriodList.forEach((time) => {
                    deathTypeList.forEach((death) => {
                        var key = [view.slug, death.slug, scale.slug, measure.slug, time.slug].join('_');
                        if (view.slug === 'deaths') {
                            dataSlugMapping[key] = measure.attr + '_' + time.attr;
                        } else {
                            dataSlugMapping[key] = 'Rate_' + time.attr;
                        }
                        i++;
                    });
                });
            });
        });
    });
    console.log(dataSlugMapping);
};

//helper dev funtion that loads style json from arcgis & merges them together
//add styles must use the same tile source, look at the style in sources.esri.url
export const mergeStyleLayersJson = async () => {
    var keysPresent = [];
    const sourceResults = {};
    var outputLayers = [];

    var sourceStyles = [
        { label: 'BG: Light Gray Land and Ocean', url: 'https://cdcarcgis.maps.arcgis.com/sharing/rest/content/items/e451293f637346d98b3f23307bddfdcf/resources/styles/root.json?f=pjson' },
        { label: 'Road Railroad: Light Gray Features', url: 'https://cdcarcgis.maps.arcgis.com/sharing/rest/content/items/2b22eb2401ca455484d68e4c17ce251a/resources/styles/root.json?f=pjson' },
        { label: 'Admin Bounds: Light Gray Borders', url: 'https://cdcarcgis.maps.arcgis.com/sharing/rest/content/items/7315a34fb5ac4d11b02c8ab8175da41e/resources/styles/root.json?f=pjson' },
        { label: 'Labels: Light Gray Labels', filter: 'labelOnly', url: 'https://cdcarcgis.maps.arcgis.com/sharing/rest/content/items/f57d6484c86e43f5bb06b10e06860d9b/resources/styles/root.json?f=pjson' }
    ];

    const filter_visibleOnly = (stylelayer) => {
        if (!'layout' in stylelayer) return true; //if there is no layout property then it's visible by default
        return stylelayer.layout.visibility !== 'none'; //either visible or undefined will be true
    };
    const filter_previouslyUsed = (stylelayer) => {
        if (keysPresent.length === 0) return false;
        return keysPresent.indexOf(stylelayer.id) !== -1;
    };
    const filter_isNotBounds = (styleLayer) => {
        return styleLayer['source-layer'] !== 'Boundary line';
    };

    const promises = sourceStyles.map(async (source, i) => {
        return await axios.get(source.url).then((res) => {
            sourceStyles[i].layers = res.data.layers;
            return res.data;
        });
    });
    await Promise.all(promises);

    sourceStyles.forEach(async (source) => {
        let invisible = 0;
        let duplicates = 0;
        var filtered = [];
        filtered = source.layers.filter((stylelayer) => {
            let duplicate = filter_previouslyUsed(stylelayer);
            let visible = filter_visibleOnly(stylelayer);
            let isNotBounds = filter_isNotBounds(stylelayer);
            if (duplicate) duplicates++;
            if (!visible) invisible++;
            return !duplicate && visible && isNotBounds;
        });
        keysPresent = keysPresent.concat(filtered.map((lyr) => lyr.id));
        outputLayers = outputLayers.concat(filtered);
        sourceResults[source.label] = { total: source.layers.length, added: filtered.length, invisible, duplicates };
    });
    console.log('Results:');
    console.log(sourceResults);
    console.log(outputLayers);
};
const fn = (obj) => obj;
const toDecimal = (val) => {
    if (val + '' === '0') return val;
    if (!val) return '';
    let num = parseFloat(val);
    if (num === -888) return 'No data available';
    if (num === -999) return 'Unstable Rate';
    return num.toFixed(1);
};
const toStringRange = (val) => {
    if (val + '' === '0') return val;
    if (!val) return '';
    return val;
};
const countTrandformFn = (val) => {
    if (val === '1-9') return '1 to 9';
    return val;
};

export const fieldMap = {
    geoid: { label: 'GEOID', years: '*', transform: fn },
    st_geoid: { label: 'State ID', years: '*', transform: fn },
    st_name: { label: 'State', years: '*', transform: fn },
    name: { label: 'Geography', years: '*', transform: fn },
    agg_count: { label: 'Grouped', years: '*', transform: fn },
    period: { label: 'Time Period', years: '*', transform: fn },

    //endpoint2
    count_sup_all: { label: 'All firearm Injury Deaths', years: '*', transform: countTrandformFn },
    count_sup_homicide: { label: 'Firearm Homicide Deaths', years: '*', transform: countTrandformFn },
    count_sup_suicide: { label: 'Firearm Suicide Deaths', years: '*', transform: countTrandformFn },
    rate_all: { label: 'Rate of All Firearm Injury Deaths per 100k People', years: '*', transform: toDecimal },
    rate_homicide: { label: 'Firearm Homicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_suicide: { label: 'Firearm Suicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_m_all: { label: 'Flag if Rate of All Firearm Injury Deaths is Modeled', years: '*', transform: toDecimal },
    rate_m_homicide: { label: 'Flag if Firearm Homicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_suicide: { label: 'Flag if Firearm Suicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_ci_all: { label: 'Credible Interval for Modeled Rate of All Firearm Injury Deaths', years: '*', transform: toDecimal },
    rate_m_ci_homicide: { label: 'Credible Interval for Modeled Firearm Homicide Rate', years: '*', transform: toDecimal },
    rate_m_ci_suicide: { label: 'Credible Interval for Modeled Firearm Suicide Rate', years: '*', transform: toDecimal },
    rate_ed: { label: 'Rate of ED Visits for Firearm Injuries per 100k ED Visits', years: 'ttm,2023,2022', transform: toDecimal },
    rate_m_ed: { label: 'Flag if Rate of ED Visits for Firearm Injury is Modeled', years: 'ttm,2023,2022*', transform: toDecimal },
    rate_m_ci_ed: { label: 'Credible Interval for Modeled Rate of ED Visits for Firearm Injury', years: 'ttm,2023,2022', transform: toDecimal },

    //endpoint 3
    count_sup_all_homicide: { label: 'Homicide Deaths', years: '*', transform: countTrandformFn },
    count_sup_all_suicide: { label: 'Suicide Deaths', years: '*', transform: countTrandformFn },
    count_sup_drug_od: { label: 'Unintentional Drug Overdose Deaths', years: '*', transform: countTrandformFn },
    count_sup_fa_deaths: { label: 'All Firearm Injury Deaths', years: '*', transform: countTrandformFn },
    count_sup_fa_homicide: { label: 'Firearm Homicide Deaths', years: '*', transform: countTrandformFn },
    count_sup_fa_suicide: { label: 'Firearm Suicide Deaths', years: '*', transform: countTrandformFn },
    rate_all_homicide: { label: 'Homicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_all_suicide: { label: 'Suicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_drug_od: { label: 'Unintentional Drug Overdose Death Rate per 100k People', years: '*', transform: toDecimal },
    rate_fa_deaths: { label: 'Rate of all firearm injury deaths per 100k People', years: '*', transform: toDecimal },
    rate_fa_homicide: { label: 'Firearm Homicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_fa_suicide: { label: 'Firearm Suicide Rate per 100k People', years: '*', transform: toDecimal },
    rate_m_all_homicide: { label: 'Flag if Homicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_all_suicide: { label: 'Flag if Suicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_drug_od: { label: 'Flag if Drug Overdose Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_fa_deaths: { label: 'Flag if Rate of All Firearm Injury Deaths is Modeled', years: '*', transform: toDecimal },
    rate_m_fa_homicide: { label: 'Flag if Firearm Homicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_fa_suicide: { label: 'Flag if Firearm Suicide Rate is Modeled', years: '*', transform: toDecimal },
    rate_m_ci_all_homicide: { label: 'Credible Interval for Modeled Homicide Rate', years: '*', transform: toDecimal },
    rate_m_ci_all_suicide: { label: 'Credible Interval for Modeled Suicide Rate', years: '*', transform: toDecimal },
    rate_m_ci_drug_od: { label: 'Credible Interval for Modeled Drug Overdose Rate', years: '*', transform: toDecimal },
    rate_m_ci_fa_deaths: { label: 'Credible Interval for Modeled Rate of All Firearm Injury Deaths', years: '*', transform: toDecimal },
    rate_m_ci_fa_homicide: { label: 'Credible Interval for Modeled Firearm Homicide Rate', years: '*', transform: toDecimal },
    rate_m_ci_fa_suicide: { label: 'Credible Interval for Modeled Firearm Suicide Rate', years: '*', transform: toDecimal }
};
